import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">CyberTeknik · Cloud Solutions</p>
        <h1>Empower Your Business with Cloud Services</h1>
        <p className="lede">
          Discover seamless data storage, backup, and management solutions tailored for your business needs. 
          Experience the reliability and security of our cloud services designed to help you thrive.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Secure Data Storage</h2>
          <p>
            Store your critical business data safely in the cloud with our robust and scalable storage solutions.
          </p>
        </article>
        <article>
          <h2>Reliable Backup Solutions</h2>
          <p>
            Protect your data with automated backup solutions that ensure your information is always safe and accessible.
          </p>
        </article>
        <article>
          <h2>Effortless Data Management</h2>
          <p>
            Streamline your operations with our intuitive management tools that simplify data handling and enhance productivity.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;